// export const fetchAvailableBuilds = async () => {
//   const response = await fetch(`${process.env.REACT_APP_PYTHON_API_URL}/api/available-builds`);
//   return response.json();
// };
import axios from '../../../api/axiosInstance';
import Env from '../../../runtimeEnv';
export const generateSingleLink = async (formData) => {
  const response = await fetch(`${Env.REACT_APP_PYTHON_API_URL}/api/generate-single-link`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });
  return response.json();
};

// ✅ Fetch therapist builds (with presigned URLs)
export const fetchTherapistBuilds = async () => {
  try {
    const response = await axios.get(`${Env.REACT_APP_PYTHON_API_URL}/api/therapist-builds`);
    return response.data; // { success: true, therapists: [...] }
  } catch (error) {
    console.error("Error fetching therapist builds:");
    return { success: false, therapists: [] };
  }
};